import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const GoogleHotels = () => {
  const [showModal, setShowModal] = useState(false);

  const baseUrl =
    "https://www.google.com/travel/hotels/entity/ChkIiMiqr_njs5_nARoML2cvMXE1Z2t4MmtwEAE/reviews";

  // Detectar el idioma del navegador (o usar 'en' si no disponible)
  const browserLang = (navigator.language || "en").split("-")[0];

  // Construir el enlace con el idioma detectado
  const link = `${baseUrl}?hl=${browserLang}`;

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explicación> */}
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="bi bi-google icon-space" />
        Google Hotels
      </button>
      {showModal && (
        <LanguageModal
          title="Google Hotels"
          icon="bi bi-google"
          links={{ [browserLang]: link }}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default GoogleHotels;
